// extracted by mini-css-extract-plugin
export default {"actionButtonStyle":"ChangeContactAddressCard_actionButtonStyle__8jXzd","form":"ChangeContactAddressCard_form__jFUCS","gridContainer":"ChangeContactAddressCard_gridContainer__XCAYY"};